//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'

import Form from '@/components/form/RegistrationForm'

export default {
  name: 'Register',
  components: { Form },
  middleware: 'unauthenticated',
  computed: {
    ...mapState('nav', ['sideNav']),
  },
}
